import { useEffect, useRef } from 'react';

/**
 * The session cookie belongs to the browser, so "Login as" in one tab makes every
 * other tab somebody else; refetch-on-focus is how a tab notices. A full reload,
 * because the query cache and everything on screen were built for the old person.
 * The first identity seen is not a change.
 */
export function useReloadOnIdentityChange(identity: string | undefined): void {
  const seen = useRef<string | undefined>(undefined);

  useEffect(() => {
    if (identity === undefined) {
      return;
    }

    if (seen.current === undefined) {
      seen.current = identity;
      return;
    }

    if (seen.current !== identity) {
      window.location.reload();
    }
  }, [identity]);
}
